import { TOGGLE_NUDGE_POPUP } from 'actions/types';

const INITIAL_STATE = {
  displayNudgePopup: false,
};

const popups = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_NUDGE_POPUP:
      return {
        ...state,
        displayNudgePopup: action.payload,
      };
    default:
      return state;
  }
};

export default popups;
